import { useSearchParams } from 'react-router-dom';

export function useQuery() {
    const [searchParams] = useSearchParams();

    return {
        get: (key: string) => searchParams.get(key),
        getAll: (key: string) => searchParams.getAll(key),
        has: (key: string) => searchParams.has(key)
    };
}